import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Card, Row, Col } from 'reactstrap';
import { s3SupportDocs } from '../../config/properties';
// Local Deps
import './NotificationCard.scss';
// Components
import CheckboxList from '../CheckboxList';
import InputField from '../form/InputField';
// import RFFInputField from '../form/RFFInputField';
// import NFButton from '../primitives/NFButton';

// const _onSubmit = data => {
//   console.log('Submitted!', data);
// };

const NotificationCard = ({
  cardIndex,
  filterGroups,
  selectedFilters,
  minimumQuantity,
  minimumEstimatedCost,
  onInputChange,
  // altupdateSettings,
}) => (
  <Card className="nf-notification-card">
    <Row>
      {/* <!-- FILTER GROUPS --> */}
      {filterGroups.map((filterGroup, idx) => (
        <Col xs={12} sm={6} lg={4} key={`col-${idx}`}>
          <CheckboxList
            {...{
              header: filterGroup.header,
              groupKey: filterGroup.groupKey,
              items: filterGroup.filters,
              onItemClick: filterGroup.onFilterClick,
              parentIndex: cardIndex,
            }}
            selectedItems={get(selectedFilters, filterGroup.groupKey, [])}
            key={`checkbox-list-${idx}`}
          />
        </Col>
      ))}
      <div className="nf-notifications-link">Want to just track Solicitations based on a list of specific NSNs? <br /><a href={`${s3SupportDocs}/Help/Using NSNs to Track Solicitations (May 2022).pdf`} target="_blank" rel="noopener noreferrer">Click here to learn more.</a></div>
    </Row>
    <Row className="nf-minimums">
      <Col>
        <Row>
          <InputField
            inputName="minimumQuantity"
            inputValue={minimumQuantity}
            onChange={({ inputName, inputValue }) => {
              onInputChange(inputValue, inputName, cardIndex);
            }}
          />
        </Row>
        <Row>
          <InputField
            inputName="minimumEstimatedCost"
            inputValue={minimumEstimatedCost}
            onChange={({ inputName, inputValue }) => {
              onInputChange(inputValue, inputName, cardIndex);
            }}
          />
        </Row>
      </Col>
      {/* <Col xs="auto">
        <NFButton
          className="nf-button--form nf-notification-card-button-save"
          // type="submit"
          onClick={altupdateSettings}
        >
          Save
        </NFButton>
      </Col> */}
    </Row>
  </Card >
);

NotificationCard.propTypes = {
  filterGroups: PropTypes.instanceOf(Array).isRequired,
  selectedFilters: PropTypes.object.isRequired,
  minimumQuantity: PropTypes.number.isRequired,
  minimumEstimatedCost: PropTypes.number.isRequired,
  cardIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  onInputChange: PropTypes.func.isRequired,
  // altupdateSettings: PropTypes.func.isRequired,
};

export default NotificationCard;



// WEBPACK FOOTER //
// ./src/components/NotificationCard/NotificationCard.jsx